import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from '@mui/material';

/**
 * Short FAQ section rendered at the bottom of each SEO page. Uses the same MUI
 * Accordion the WP cards already use. The same `faqs` array feeds the FAQPage
 * JSON-LD (see seoSchema.faqPageSchema) so the rich result matches the page.
 */
const SeoFaq = ({ faqs, heading = 'Vanliga frågor' }) => {
  if (!faqs || faqs.length === 0) {
    return null;
  }

  return (
    <section>
      <Typography variant="h2" component="h2" sx={{ fontSize: '1.5rem', fontWeight: 700, mb: 2 }}>
        {heading}
      </Typography>
      {faqs.map((faq, index) => (
        <Accordion key={index} disableGutters elevation={0} square sx={{ borderTop: '1px solid #eee' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ fontWeight: 600 }}>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ color: '#444' }}>{faq.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </section>
  );
};

export default SeoFaq;
